<script setup lang="ts">
import { computed } from 'vue';

import VDialog from '@components/dialogs/VDialog/VDialog.vue';

import type {
  CreativePreviewEmits,
  CreativePreviewProps,
} from './types';

const props = defineProps<CreativePreviewProps>();
const emit = defineEmits<CreativePreviewEmits>();

const isVisible = computed(() => !!props.creative);
</script>

<template>
  <VDialog
    :visible="isVisible"
    :title="creative?.title"
    @hide="emit('hide')"
  >
    <img
      v-if="creative?.format === 'jpeg' || creative?.format === 'gif' || creative?.format === 'png'"
      :src="creative?.img"
      :alt="creative?.title"
      class="m-auto"
    >
    <iframe
      v-else-if="creative?.format === 'bannerflow_gif' || creative?.format === 'iframe'"
      title="creative banner preview"
      :src="creative?.body"
      :width="creative?.width"
      :height="creative?.height"
      class="m-auto border-0"
    />
  </VDialog>
</template>
